'use strict';


export default function($log) {
	'ngInject';

	return function filter(location, moreDetail) {
		if (!location) {
			return 'No address';
		}
		if (location.route) {
			let address = `${location.street_number} ${location.route}`.replace(/(^\s+|\s+$)/g,'');
			if (!moreDetail) {
				return address;
			}
			if (location.locality) {
				address += `, ${location.locality}`;
			}
			if (location.administrative_level_1) {
				address += `, ${location.administrative_level_1}`;
			}
			return address;
		} else {
			return location.raw;
		}
	}
}
